import React, { useState, useEffect } from 'react';
import { getScoreScale } from '../../services/studentService';

/* Кнопка «Шкала перевода баллов» (стеклянная, рядом с колокольчиком в «Вариантах»)
   + красивое всплывающее окно с таблицей перевода. ЕГЭ — сетка «первичный → тестовый»
   в несколько колонок (широко, без прокрутки). ОГЭ — диапазоны оценок. */

const IcScale = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v18" /><path d="M5 7h14" /><path d="M5 7l-3 6a3 3 0 0 0 6 0z" /><path d="M19 7l-3 6a3 3 0 0 0 6 0z" /><path d="M8 21h8" />
  </svg>
);
const IcClose = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>);

export default function ScoreScaleButton({ courseId, examType, variant }) {
  const [open, setOpen] = useState(false);
  const [scale, setScale] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getScoreScale(courseId).then(r => setScale(r.data)).catch(() => setScale(null)).finally(() => setLoaded(true));
  }, [courseId]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const type = scale?.examType || examType;
  const isOge = type === 'ОГЭ';

  // ЕГЭ: пары «первичный → тестовый» (индекс массива = первичный балл), с 1-го.
  const egePairs = (!isOge && Array.isArray(scale?.secondary))
    ? scale.secondary.map((sec, primary) => ({ primary, sec })).filter(p => p.primary >= 1)
    : [];
  // ОГЭ: диапазоны оценок.
  const ogeGrades = (isOge && Array.isArray(scale?.grades)) ? scale.grades : [];

  return (
    <>
      <button
        className={`scale-btn${variant === 'inline' ? ' scale-btn--inline' : ''}`}
        onClick={() => setOpen(true)}
        title="Шкала перевода баллов"
        aria-label="Шкала перевода баллов"
      >
        <IcScale />
        <span className="scale-btn-txt">Шкала перевода баллов</span>
      </button>

      {open && (
        <div className="scale-ov" onClick={() => setOpen(false)}>
          <div className="scale-modal" onClick={e => e.stopPropagation()}>
            <div className="scale-head">
              <div>
                <div className="scale-title">Шкала перевода баллов{type ? ` · ${type}` : ''}</div>
                <div className="scale-sub">{isOge ? 'Первичный балл → оценка' : 'Первичный балл → тестовый балл'}</div>
              </div>
              <button className="scale-x" onClick={() => setOpen(false)} aria-label="Закрыть"><IcClose /></button>
            </div>

            <div className="scale-body">
              {!loaded ? (
                <div className="scale-empty">Загрузка…</div>
              ) : isOge && ogeGrades.length ? (
                <div className="scale-oge">
                  {ogeGrades.map(g => (
                    <div key={g.grade} className={`scale-oge-row g${g.grade}`}>
                      <span className="scale-oge-grade">{g.grade}</span>
                      <div className="scale-oge-info">
                        <div className="scale-oge-lbl">Оценка «{g.grade}»</div>
                        <div className="scale-oge-range">{g.min}–{g.max} первичных баллов</div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : egePairs.length ? (
                <div className="scale-grid">
                  {egePairs.map(p => (
                    <div key={p.primary} className="scale-cell">
                      <span className="scale-prim">{p.primary}</span>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--text-3)', flexShrink: 0 }}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="13 6 19 12 13 18" /></svg>
                      <span className="scale-sec">{p.sec}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="scale-empty">Шкала перевода для этого курса пока не задана.</div>
              )}
            </div>

            <div className="scale-foot">
              {isOge ? 'Максимум — ' : 'Максимальный первичный балл — '}<b>{scale?.maxPrimary ?? '—'}</b>{isOge ? ' первичных баллов' : ''}.
            </div>
          </div>
        </div>
      )}
    </>
  );
}
